import React from "react";
//import classnames from "classnames";
// javascript plugin used to create scrollbars on windows
//import PerfectScrollbar from "perfect-scrollbar";
import emailjs from '@emailjs/browser';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";

export default function ContactPage() {

  emailjs.init({
    publicKey: 'NsqeZk_-457qe3up6',
  });
  const [formData, setFormData] = React.useState({});
  const [enviado, setEnviado] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (enviado == false) {
    emailjs
      .send('service_7h3jsne', 'template_46zz0wu', formData, {
        publicKey: 'NsqeZk_-457qe3up6',
      })
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setEnviado(true);
      
        },
        (err) => {
          console.log('FAILED...', err);
        },
      );
    }
    };  

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="page-header">
          <img
            alt="..."
            className="dots"
            src={require("assets/img/dots.png")}
          />
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />
        <section className="section">
          <Container>
            <Row>
              <Col md="6">
                <Card className="card-plain">
                  <CardHeader>
                    <h1 className="profile-title text-left">Contato</h1>
                    <h5 className="text-on-back">01</h5>
                  </CardHeader>
                  <CardBody>
                  {enviado == false ? (
                    <Form onSubmit={sendEmail}>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <label>Seu nome completo</label>
                            <Input name="nome" disabled={isSubmitting} type="text" onChange={handleChange}/>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <label>Seu e-mail</label>
                            <Input name="email" disabled={isSubmitting} type="email" onChange={handleChange}/>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <label>Celular</label>
                            <Input name="celular" disabled={isSubmitting} type="text" onChange={handleChange}/>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <label>Assunto</label>
                            <Input name="assunto" disabled={isSubmitting} type="text" onChange={handleChange}/>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup>
                            <label>Mensagem</label>
                            <Input name="mensagem" disabled={isSubmitting} placeholder="Sua mensagem!" type="textarea" onChange={handleChange}/>
                          </FormGroup>
                        </Col>
                      </Row>
          
                      <Button
                        className="btn-round float-right"
                        color="primary"
                        data-placement="right"
                        id="tooltip341148792"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        
                        {isSubmitting ? 'Enviando...' : 'Enviar mensagem'}
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="right"
                        target="tooltip341148792"
                      >
                        Mal posso esperar pela sua mensagem
                      </UncontrolledTooltip>
                    </Form>
                    ) : (
                      <section>

                        <p>Mensagem enviada com sucesso!</p> 
                      </section>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col className="ml-auto" md="4">
                <div className="info info-horizontal">
                  <div className="icon icon-primary">
                    <i className="tim-icons icon-square-pin" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Nosso endereço</h4>
                    <p>Av. Comendador Franco, 5625 - Uberaba</p>
                    <p className="text-danger"><strong color="primary">Entrada pela:</strong></p>
                    <p>Rua Eng. Ademar Munhoz, 160</p>
                    <p>Curitiba - Paraná - Brasil</p>
                  </div>
                </div>
                <div className="info info-horizontal">
                  <div className="icon icon-primary">
                    <i className="tim-icons icon-mobile" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Ligue para nós</h4>
                    <p>
                      Igreja Conectados<br />
                      +55 41 99871-8697 <br />
                      De Segunda a sexta das 09 às 18 horas
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        </div>
        <Footer />
      </div>
    </>
  );
}
